import React from "react";

export const parseCriteriaNames = (value) => {
    if (value == null || value === "") {
        return [];
    }

    if (Array.isArray(value)) {
        return value.map((item) => String(item).trim()).filter(Boolean);
    }

    if (typeof value === "string") {
        return value.split(",").map((item) => item.trim()).filter(Boolean);
    }

    return [];
};

const AudienceCriteriaPillsInline = ({ segmentNames = [], tagNames = [], t, className = "" }) => {
    const segments = parseCriteriaNames(segmentNames);
    const tags = parseCriteriaNames(tagNames);
    const hasCriteria = segments.length > 0 || tags.length > 0;

    if (!hasCriteria) {
        return (
            <p className={`planDetailCard-group-name audience-criteria-empty mb-0 ${className}`.trim()}>
                {t("business_customers.no_criteria_specified")}
            </p>
        );
    }

    return (
        <div className={`audience-criteria-pill-group ${className}`.trim()}>
            {segments.length > 0 && (
                <div className="audience-criteria-row flex flex-wrap gap-2 pb-2">
                    {segments.map((label) => (
                        <span key={`segment-${label}`} className="segment-tag-div">
                            <span className="segment-class">{label}</span>
                        </span>
                    ))}
                </div>
            )}
            {tags.length > 0 && (
                <div className="audience-criteria-row flex flex-wrap gap-2">
                    {tags.map((label) => (
                        <span key={`tag-${label}`} className="tag-div-main">
                            <span className="tag-class">{label}</span>
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default AudienceCriteriaPillsInline;
